import * as React from 'react';
import { Input } from '@snoam/pinata';
import { useEffect, useState } from 'react';

export interface IInputFieldProps {
  initialFocus?: boolean;
  validationErrorMessage?: any;
  label?: string;
  placeholder?: string;
  value?: string;
  onChange?: (e: React.FormEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FormEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  type?: string;
  maxLength?: number;
  validator?: (value: string) => boolean;
  validatorWhileTyping?: any;
  formSubmitted?: boolean;
  overrideValidationError?: boolean;
  onEnter?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const InputField: React.FC<IInputFieldProps> = props => {
  const [showValidationError, setValidationError] = useState<string>('');
  const [isValid, setIsValid] = useState<boolean>(false);

  useEffect(() => {
    const { value, validator } = props;
    const showValidationError =
      value && validator
        ? !validator(value)
          ? props.validationErrorMessage
          : ''
        : '';
    setValidationError(showValidationError);
  }, []);

  useEffect(() => {
    if (props.formSubmitted) {
      const { value, validator } = props;
      const isError =
        validator && !validator(value) ? props.validationErrorMessage : '';
      setValidationError(isError);
    }
  }, [props]);

  const onChange = (e: React.FormEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value;
    const { validator, validatorWhileTyping, formSubmitted } = props;
    const isValid = !validator || validator(value);
    if (isValid) {
      setValidationError('');
      setIsValid(true);
    } else {
      if (formSubmitted) {
        setValidationError(props.validationErrorMessage);
      } else if (validatorWhileTyping) {
        const isError = !validatorWhileTyping(value)
          ? props.validationErrorMessage
          : '';
        setValidationError(isError);
      }
    }
    if (props.onChange) {
      props.onChange(e);
    }
  };

  const onBlur = (e: any) => {
    const value = e.target.value;
    if (value) {
      const validator = props.validator;
      const isError =
        validator && !validator(value) ? props.validationErrorMessage : '';
      setValidationError(isError);
    }

    if (props.onBlur) {
      props.onBlur(e);
    }
  };

  const onKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.charCode === 13 && props.onEnter) {
      props.onEnter(e);
      e.preventDefault();
    }
  };

  const {
    value,
    disabled,
    maxLength,
    initialFocus,
    placeholder,
    label
  } = props;
  const inputType = props.type ? props.type : 'text';
  return (
    <div>
      <Input
        label={label}
        autoFocus={initialFocus}
        type={inputType}
        className="form-control"
        placeholder={placeholder}
        onChange={e => onChange(e)}
        onBlur={e => onBlur(e)}
        value={value}
        disabled={disabled}
        maxLength={maxLength}
        errorMsg={showValidationError}
        validMsg={isValid}
        onKeyPress={e => onKeyPress(e)}
        clearable={true}
      />
    </div>
  );
};

export default InputField;
